export default __webpack_public_path__ + "static/media/Mantle.795fe556.svg";